module.exports = __webpack_public_path__ + "static/media/bathSalts.ca9c505c.jpg";